import styled from "styled-components";

export const AntiBotNoticeText = styled.p<{ color?: string }>`
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.7;
  color: ${(props) => props.color || "inherit"};
`;
